<template>
  <v-container>
    <h1>Produtos</h1>
    <p>Lista de produtos aqui...</p>
  </v-container>
</template>

<script setup>
</script>
